import fig1 from '../../assets/sdmtfigures/symbol-01.svg';
import fig2 from '../../assets/sdmtfigures/symbol-02.svg';
import fig3 from '../../assets/sdmtfigures/symbol-03.svg';
import fig4 from '../../assets/sdmtfigures/symbol-04.svg';
import fig5 from '../../assets/sdmtfigures/symbol-05.svg';
import fig6 from '../../assets/sdmtfigures/symbol-06.svg';
import fig7 from '../../assets/sdmtfigures/symbol-07.svg';
import fig8 from '../../assets/sdmtfigures/symbol-08.svg';
import fig9 from '../../assets/sdmtfigures/symbol-09.svg';

export default {
  figure_1: fig1,
  figure_2: fig2,
  figure_3: fig3,
  figure_4: fig4,
  figure_5: fig5,
  figure_6: fig6,
  figure_7: fig7,
  figure_8: fig8,
  figure_9: fig9,
};
